import { render, staticRenderFns } from "./AnexoComprovante.vue?vue&type=template&id=eb52b65c&scoped=true"
import script from "./AnexoComprovante.vue?vue&type=script&lang=js"
export * from "./AnexoComprovante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb52b65c",
  null
  
)

export default component.exports